import styled from "styled-components";

export const AboutMeContent = styled.div`
  grid-area: c;
  max-width: 90vw;
`;
